import React, { useState } from 'react';

export enum BannerVariant {
  Info = 'info',
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
}
type BannerSize = 'reg' | 'slim';

interface BannerProps {
  showCloseButton?: boolean;
  size?: BannerSize;
  text: string;
  variant: BannerVariant;
}

const ICON_CLASS_MAP: Record<BannerVariant, string> = {
  [BannerVariant.Error]: 'icon-info displayed-icon icon-error',
  [BannerVariant.Success]: 'icon-ds-check-circle displayed-icon icon-success',
  [BannerVariant.Warning]: 'icon-ds-warning displayed-icon',
  [BannerVariant.Info]: 'icon-info displayed-icon',
};

const Banner: React.FC<BannerProps> = ({ showCloseButton = true, size = 'reg', text, variant }) => {
  const [visible, setVisible] = useState(true);
  if (!visible) return null;

  const iconClass = ICON_CLASS_MAP[variant];
  const sizeClass = size === 'slim' ? 'banner-slim' : '';

  return (
    <div className="banner-container">
      <div className={`banner-v2 banner-${variant} ${sizeClass}`} data-testid={`banner-${variant}`} role="status" aria-live="polite">
        <div className="banner-content">
          <i className={iconClass} />
          <span className="banner-text">{text}</span>
        </div>
        {showCloseButton && (
          <button type="button" className="clear-term" data-testid="banner-icon-close" onClick={() => setVisible(false)} aria-label="Dismiss notification">
            <i className="icon-cross-thin" aria-hidden="true" />
          </button>
        )}
      </div>
    </div>
  );
};

export default Banner;
